import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  height: 100vh;
`;

export const NotFoundUnknown = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NotFoundUnknownText = styled.div`
  font-size: 20px;
  text-align: center;
`;
